module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA8CAMAAACQLyDIAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURf7+/uHh4fb29urq6uPj4/v7++fn5+Xl5fn5+ezs7PDw8PLy8vT09Pz8/O7u7g6ARCMAAAArSURBVAjXVcGHDQAgDAOwsjf/nwuKoqq1JYifuXHFpAdenrhwY8Rulv9oelCeAY1NVoCgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/yaers-bg.png
// module id = 551
// module chunks = 0